'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.beachShortFilter = beachShortFilter;
var angular = require('angular');

/*@ngInject*/
function beachShortFilter() {
  return function (input) {
    var beachKey = {
      'Ocean Beach': 'OB',
      'Fair Harbor': 'FH',
      Atlantique: 'AT',
      Dunewood: 'DW',
      Kismet: 'KI',
      'Ocean Bay Park': 'OBP',
      Seaview: 'SV',
      Saltaire: 'SA'
    };
    return beachKey[input];
  };
}

exports.default = angular.module('fiapiApp.beachShort', []).filter('beachShort', beachShortFilter).name;


// WEBPACK FOOTER //
// ./client/filters/beachShort/beachShort.filter.js